import { __decorate, __metadata } from "tslib";
import { ChargeTypeEnum } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { Equals, IsNumber, IsOptional, Min } from 'class-validator';
import { ServiceChargeExposeGroup } from '../interface';
import { PatchBaseChargeDto } from './PatchBaseChargeDto';
export class PatchFixedChargeDto extends PatchBaseChargeDto {
    constructor() {
        super(...arguments);
        this.type = ChargeTypeEnum.FIXED;
    }
}
__decorate([
    ApiPropertyOptional({ enum: ChargeTypeEnum, default: ChargeTypeEnum.FIXED }),
    IsOptional({ groups: [ServiceChargeExposeGroup.PATCH] }),
    Equals(ChargeTypeEnum.FIXED, { always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchFixedChargeDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'Amount in smallest denomination (100 means $1)', example: 100 }),
    IsOptional({ groups: [ServiceChargeExposeGroup.PATCH] }),
    IsNumber({ maxDecimalPlaces: 0, allowInfinity: false, allowNaN: false }),
    Min(0, { always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], PatchFixedChargeDto.prototype, "amount", void 0);
//# sourceMappingURL=PatchFixedChargeDto.js.map